import { SidebarItem, TopicItem } from "mta-rkvr-styles";
import { UserRoleType } from "./types/admin/User";
import {
  ADMINISTRATION,
  ASSETS,
  BALANCE,
  BULKEDIT,
  CONTRACTS,
  ENERGYEFFICIENCY,
  OPENDATA,
  PROCEEDINGS,
  REALESTATEUNIT,
  REPORTS,
  SUMMARY,
  THI_MANAGEMENT,
  UNIT_MANAGEMENT,
  UNIT_MANAGEMENT_BULKEDIT,
  INVESTMENT_PROJECT_SEARCH,
  INVESTMENT_PROJECT_BULKEDIT,
  VAT_MANAGEMENT,
  CONTRACTS_WORKSPACES,
} from "./util/paths";
import {
  canRoleOpenAdminNotifications,
  canRoleOpenAdminThiAndVat,
  canRoleOpenBulkEdit,
  canRoleOpenContractsWorkSpaces,
  canRoleOpenOrgs,
  canRoleOpenStartProceeding,
  canRoleOpenStartRealEstateUnit,
  canRoleOpenUsers,
} from "./util/rightsManagers/sidebarItems/viewRightsManager";

export function getSidebarItems(types: UserRoleType[], isLoggedIn: boolean): SidebarItem[] {
  return [
    homepageItems,
    getAssetItems(types),
    getProceedingItems(types),
    getContractItems(types),
    getReportItems(isLoggedIn),
    getRealEstateUnitItems(types),
    getAdministrationItems(types),
    notificationsSubscriptionsItems,
  ];
}

const homepageItems = { topicItems: [], mainPath: "/" };

const getAssetItems = (types: UserRoleType[]) => {
  const topicItems: TopicItem[] = canRoleOpenBulkEdit(types)
    ? [
        {
          header: "Vara otsing",
          listItems: [],
        },
        {
          header: "Mass muutmine",
          listItems: [],
          path: BULKEDIT,
        },
      ]
    : [];
  return {
    topicItems,
    mainPath: ASSETS,
  };
};

const getProceedingItems = (types: UserRoleType[]) => {
  const topicItems: TopicItem[] = canRoleOpenStartProceeding(types)
    ? [
        {
          header: "Menetluse otsing",
          listItems: [],
        },
        {
          header: "Menetluse alustamine",
          listItems: [],
          path: "/alusta",
        },
      ]
    : [];

  return {
    topicItems,
    mainPath: PROCEEDINGS,
  };
};
const getRealEstateUnitItems = (types: UserRoleType[]) => {
  const topicItems: TopicItem[] = canRoleOpenStartRealEstateUnit(types)
    ? [
        {
          header: "KVÜ/PKVÜ otsing",
          listItems: [],
        },
        {
          header: "KVÜ alustamine",
          listItems: [],
          path: "/alusta-kvu",
        },
        {
          header: "PKVÜ alustamine",
          listItems: [],
          path: "/alusta-pkvu",
        },
        {
          header: "KVÜ üldandmete massmuutmine",
          listItems: [],
          path: BULKEDIT,
        },
        {
          header: "KVÜ juhtimiskava andmete massmuutmine",
          listItems: [],
          path: UNIT_MANAGEMENT_BULKEDIT,
        },
        {
          header: "Investeeringutaotluse otsing",
          listItems: [],
          path: INVESTMENT_PROJECT_SEARCH,
        },
        {
          header: "PKVÜ investeeringuprojekti andmete massmuutmine",
          listItems: [],
          path: INVESTMENT_PROJECT_BULKEDIT,
        },
      ]
    : [];

  return {
    topicItems,
    mainPath: REALESTATEUNIT,
  };
};

const getContractItems = (types: UserRoleType[]) => {
  const topicItems: TopicItem[] = canRoleOpenContractsWorkSpaces(types)
    ? [
        {
          header: "Lepingute otsing",
          listItems: [],
        },
        {
          header: "Lepingute haldamine",
          listItems: [],
          path: CONTRACTS_WORKSPACES,
        },
      ]
    : [];
  return {
    topicItems,
    mainPath: CONTRACTS,
  };
};

const getReportItems = (isLoggedIn: boolean) => {
  const topicItems: TopicItem[] = [
    {
      header: "Avaandmed",
      listItems: [],
      path: OPENDATA,
    },
    {
      header: "Energiatõhususe inventuur",
      listItems: [],
      path: ENERGYEFFICIENCY,
    },
  ];
  isLoggedIn &&
    topicItems.unshift(
      {
        header: "Bilansi päring",
        listItems: [],
        path: BALANCE,
      },
      {
        header: "Bilansi koondaruanne",
        listItems: [],
        path: SUMMARY,
      },
    );
  return {
    topicItems,
    mainPath: REPORTS,
  };
};

const getAdministrationItems = (types: UserRoleType[]) => {
  const topicItems: TopicItem[] = [];
  canRoleOpenOrgs(types) &&
    topicItems.push({
      header: "Organisatsioonid",
      listItems: [],
      path: "/organisatsioonid",
    });
  canRoleOpenUsers(types) &&
    topicItems.push({
      header: "Kasutajad",
      listItems: [],
      path: "/kasutajad",
    });

  canRoleOpenAdminNotifications(types) &&
    topicItems.push(
      {
        header: "Teated",
        listItems: [],
        path: "/teated",
      },
      {
        header: "Loendite haldus",
        listItems: [],
        path: "/loendite-haldus",
      },
    );
  canRoleOpenAdminThiAndVat(types) &&
    topicItems.push(
      {
        header: "Tegevuskulude käibemaksumäärad",
        listItems: [],
        path: VAT_MANAGEMENT,
      },
      {
        header: "Tarbijahinnaindeksi aegrida",
        listItems: [],
        path: THI_MANAGEMENT,
      },
      {
        header: "Juhtimiskava haldamine",
        listItems: [],
        path: UNIT_MANAGEMENT,
      },
    );
  return {
    topicItems,
    mainPath: ADMINISTRATION,
  };
};

const notificationsSubscriptionsItems = {
  topicItems: [],
  mainPath: "teavituste-tellimine",
};
